import { render, staticRenderFns } from "./SurveyFormSystem.vue?vue&type=template&id=060fa243&scoped=true"
import script from "./SurveyFormSystem.vue?vue&type=script&lang=js"
export * from "./SurveyFormSystem.vue?vue&type=script&lang=js"
import style0 from "./SurveyFormSystem.vue?vue&type=style&index=0&id=060fa243&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060fa243",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060fa243')) {
      api.createRecord('060fa243', component.options)
    } else {
      api.reload('060fa243', component.options)
    }
    module.hot.accept("./SurveyFormSystem.vue?vue&type=template&id=060fa243&scoped=true", function () {
      api.rerender('060fa243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SurveyForm/SurveyFormSystem.vue"
export default component.exports